<template>
    <div class="polycanvas">
        <div class="canvaswrap">
        <svg class="canvas">
            <!-- flip over x-axis -->
            <g transform="translate(0,400) scale(1,-1)">
                <path :d="subpath"
                stroke="#3498db"
                stroke-width="1"
                fill="#fcfcfc"
                fill-rule="evenodd"
                ></path>

                <path :d="clippath"
                stroke="#e74c3c"
                stroke-width="1"
                fill="#fcfcfc"
                fill-rule="evenodd"
                ></path>

                <path :d="resultpath"
                stroke="#2c3e50"
                stroke-width="1"
                fill="#42b983"
                fill-rule="evenodd"
                ></path>
            </g>
        </svg>
        <div :class="{ 'loading': calculating, 'not-loading': !calculating }">
            Loading
        </div>
        </div>
        <h3>Result</h3>
        <pre ref="TEST" class="result language-json" v-html="result_html">></pre>
    </div>
</template>

<script>
import { mapState } from 'vuex'

//import Prism from 'primsjs'
//const Prism = require('prismjs')
//require('prismjs/components/prism-json.js')

export default {
    name: 'poly-canvas',
    data () {
        return {}
    },
    computed: {
        subpath () {
            return this.build_path(this.subject)
        },
        clippath () {
            return this.build_path(this.clipping)
        },
        resultpath () {
            return this.build_path(this.result)
        },
        result_str () {
            let result = this.result
            let str = '[\n'
            let i = 0
            for (let poly of result) {
                i += 1
                str += '  ' + JSON.stringify(poly)
                if (i !== result.length) {
                    str += ','
                }
                str += '\n'
            }
            str += ']\n'
            return str
        },
        result_html () {
            return '<code>' + this.result_str + '</code>'
        },
        ...mapState({
            subject: state => state.subject,
            clipping: state => state.clipping,
            result: state => state.result,
            calculating: state => state.calc
        })
    },
    watch: {
        result_html () {
            try {
                Prism.highlightAll()
            } catch (e) {
                console.log(e)
            }
        }
    },
    methods: {
        build_path (polygons) {
            let ret = ''
            for (let poly of polygons) {
                ret += 'M '
                + this.unflatten_points(poly).map((p) => p.join(' ')).join(' ')
                + ' '
            }
            return ret
        },
        unflatten_points (points) {
            let res = [];
            for (let i = 0; i < points.length; i+=2) {
                res.push([points[i], points[i+1]])
            }
            return res
        }
    }
}
</script>

<style>
.polycanvas {
    text-align: left;
}
.canvaswrap {
    position: relative;
}
.canvas {
    width:400px;
    height:400px;
    overflow: visible;
    border: 1px solid rgba(0,0,0,0.5);
    box-shadow: 2px 2px 5px -2px rgba(0,0,0,0.6);
    width: 400px;
    height: 400px;
}
.result {
    font-size: 0.8rem;
    max-width: calc(400px - 2em); /* account for 1em padding from prism */
}
.not-loading {
    opacity: 0;
}
.loading {
    opacity: 1;
    transition: opacity 1.5s ease 0.75s;
    position: absolute;
    width: 100%;
    top: 200px;
    font-size: 2rem;
    text-align: center;
    z-index: 999;
    text-shadow: 1px 1px 3px rgba(150, 150, 150, 0.75);
}
</style>



// WEBPACK FOOTER //
// PolyCanvas.vue?97ea17be